export const SERVICE_AMOUNTS = {
    MEMBER_BASIC: 132000,
    MEMBER_OPTION01: 132000,
    NON_MEMBER_BASIC: 220000,
    NON_MEMBER_OPTION01: 440000,
  };